import { render, staticRenderFns } from "./BulkUpiMandate.vue?vue&type=template&id=6234ab00&"
import script from "./BulkUpiMandate.vue?vue&type=script&lang=js&"
export * from "./BulkUpiMandate.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpiMandate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VChip,VFileInput})
